"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.LOADING_P = exports.LOADING_H1 = exports.LOADING_WRAPPER = exports.CREATE_TEXT = exports.CREATE_BOX = exports.CREATE_WRAPPER = exports.WRAPPER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    SIZE_PARAMS = {
  square: {
    width: "205px",
    height: "205px",
    maxWrapperHeight: "255px"
  },
  small: {
    width: "300px",
    height: "70px",
    maxWrapperHeight: "80px"
  },
  medium: {
    width: "300px",
    height: "150px",
    maxWrapperHeight: "160px"
  }
},
    WRAPPER = function WRAPPER(a) {
  return (0, _cxs["default"])({
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    flexWrap: "wrap",
    maxHeight: SIZE_PARAMS[a].maxWrapperHeight
  });
};

exports.WRAPPER = WRAPPER;
var CREATE_WRAPPER = (0, _cxs["default"])({
  marginRight: "16px"
});
exports.CREATE_WRAPPER = CREATE_WRAPPER;

var CREATE_BOX = function CREATE_BOX(a) {
  return (0, _cxs["default"])({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: SIZE_PARAMS[a].width,
    height: SIZE_PARAMS[a].height,
    cursor: "pointer",
    background: "\n    linear-gradient(to right, ".concat(_vars.COLOURS.grey.athens.bigFat, " 50%, transparent 0%) top/20px 2px repeat-x,\n    linear-gradient(").concat(_vars.COLOURS.grey.athens.bigFat, " 50%, transparent 0%) right/2px 20px repeat-y,\n    linear-gradient(to right, ").concat(_vars.COLOURS.grey.athens.bigFat, " 50%, transparent 0%) bottom/20px 2px repeat-x,\n    linear-gradient(").concat(_vars.COLOURS.grey.athens.bigFat, " 50%, transparent 0%) left/2px 20px repeat-y\n  "),
    ":hover": {
      background: "\n      linear-gradient(to right, ".concat(_vars.COLOURS.grey.athens.smallSkinny, " 50%, transparent 0%) top/20px 2px repeat-x,\n      linear-gradient(").concat(_vars.COLOURS.grey.athens.smallSkinny, " 50%, transparent 0%) right/2px 20px repeat-y,\n      linear-gradient(to right, ").concat(_vars.COLOURS.grey.athens.smallSkinny, " 50%, transparent 0%) bottom/20px 2px repeat-x,\n      linear-gradient(").concat(_vars.COLOURS.grey.athens.smallSkinny, " 50%, transparent 0%) left/2px 20px repeat-y\n    ")
    },
    "> .create-text": {
      marginLeft: "8px"
    }
  });
};

exports.CREATE_BOX = CREATE_BOX;
var CREATE_TEXT = (0, _cxs["default"])({
  color: _vars.COLOURS.grey.regent,
  fontWeight: _vars.FONT_WEIGHTS.regular,
  textTransform: "uppercase",
  textAlign: "center",
  marginTop: "15px",
  letterSpacing: "1px"
});
exports.CREATE_TEXT = CREATE_TEXT;
var LOADING_WRAPPER = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  marginRight: "16px",
  padding: "24px",
  width: "157px",
  height: "157px",
  background: _vars.COLOURS.mono.white
});
exports.LOADING_WRAPPER = LOADING_WRAPPER;
var LOADING_H1 = (0, _cxs["default"])({
  height: "15px",
  backgroundColor: _vars.COLOURS.grey.athens.bigFat,
  width: "153px",
  borderRadius: "6px",
  marginBottom: "16px"
});
exports.LOADING_H1 = LOADING_H1;

var LOADING_P = function LOADING_P(a) {
  return (0, _cxs["default"])({
    height: "15px",
    marginTop: "8px",
    backgroundColor: _vars.COLOURS.grey.athens.bigFat,
    width: "".concat(a, "px"),
    opacity: "0.75",
    borderRadius: "6px"
  });
};

exports.LOADING_P = LOADING_P;